export default "__VITE_ASSET__apdPFvPi__"